import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function AppShell() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <div className="App min-h-screen bg-[#FCFCFD] text-slate-900">
            <ScrollToTop />
            {!isAdmin && <Header />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/work" element={<Work />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/leads" element={<AdminLeads />} />
            </Routes>
            {!isAdmin && <Footer />}
            {!isAdmin && <WhatsAppButton />}
            <Toaster position="top-center" richColors />
        </div>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <AppShell />
        </BrowserRouter>
    );
}

export default App;
